/** Quick-bar defaults — most common chat reactions. */
export const COMMON_EMOJIS = ['👍', '❤️', '😂', '🔥', '🎉', '🐴'] as const

/** Larger picker set (still curated — not the full Unicode emoji catalog). */
export const PICKER_EMOJIS = [
  ...COMMON_EMOJIS,
  '👏',
  '🙏',
  '💯',
  '😎',
  '😢',
  '😮',
  '😡',
  '💪',
  '✅',
  '❌',
  '🎯',
  '🐎',
  '🏁',
  '🏆',
  '🍻',
  '🎂',
  '👀',
  '🙌',
  '🤝',
  '😅',
  '🤣',
  '😊',
  '🥰',
  '🤔',
  '😴',
  '🫡',
  '🍀',
  '⚡',
  '🌟',
  '💚',
  '💙',
  '🖤',
  '🤍',
  '🍺',
  '🥃',
  '🍽️',
  '⛳',
  '🏈',
  '📝',
  '🔔',
] as const

const RECENT_KEY = 'railbirds.chat.recentEmojis'
const RECENT_MAX = 8

export function getRecentEmojis(): string[] {
  try {
    const raw = localStorage.getItem(RECENT_KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw)
    if (!Array.isArray(parsed)) return []
    return parsed.filter((e) => typeof e === 'string').slice(0, RECENT_MAX)
  } catch {
    return []
  }
}

export function rememberEmoji(emoji: string) {
  try {
    const next = [emoji, ...getRecentEmojis().filter((e) => e !== emoji)].slice(0, RECENT_MAX)
    localStorage.setItem(RECENT_KEY, JSON.stringify(next))
  } catch {
    // ignore quota / private mode
  }
}

export function quickBarEmojis(): string[] {
  const recent = getRecentEmojis()
  const merged = [...recent, ...COMMON_EMOJIS.filter((e) => !recent.includes(e))]
  return merged.slice(0, 6)
}
